var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "page", attrs: { id: "notifications", role: "main" } },
    [
      _c("div", { staticClass: "o-wrapper u-m-y16 u-m-y10@m u-m-y6@s" }, [
        _c("div", { staticClass: "o-grid o-grid--center" }, [
          _c(
            "div",
            { staticClass: "o-grid__item u-width-8/12 u-width-full@m" },
            [
              _c("div", { staticClass: "c-notifications__title u-m-b3" }, [
                _c("h4", [_vm._v("Your notifications")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: "#0" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.markAllRead.apply(null, arguments)
                      },
                    },
                  },
                  [_c("p", [_vm._v("Mark all as read")])]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.notifications, function (notification, index) {
                return _c("div", { staticClass: "c-notifications__wrap" }, [
                  _c(
                    "a",
                    {
                      class: [
                        "c-notifications",
                        notification.read === false ? "new" : "",
                      ],
                      attrs: { href: "#", "data-nid": notification.id },
                    },
                    [
                      _c("div", { staticClass: "c-notifications-wrap" }, [
                        _c("div", { staticClass: "c-notifications-content" }, [
                          _c("div", { staticClass: "c-notifications-detail" }, [
                            _c("div", { staticClass: "c-avatar" }, [
                              _c("img", {
                                attrs: {
                                  src: notification.notifierAvatar,
                                  alt: "avatar",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              [
                                _vm._l(
                                  notification.notifiers,
                                  function (notifier, index) {
                                    return [
                                      index < 2
                                        ? _c(
                                            "strong",
                                            {
                                              attrs: {
                                                "data-user":
                                                  "/u/" + notifier.username,
                                              },
                                            },
                                            [_vm._v(_vm._s(notifier.username))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      notification.notifiers.length === 2 &&
                                      index === 0
                                        ? _c("span", [_vm._v("and")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      notification.notifiers.length > 2 &&
                                      index === 0
                                        ? _c("span", [_vm._v(",")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 2
                                        ? _c("span", [
                                            _vm._v(
                                              "and\n                                                " +
                                                _vm._s(
                                                  notification.notifiers
                                                    .length - 2
                                                ) +
                                                "\n                                                other"
                                            ),
                                          ])
                                        : _vm._e(),
                                      notification.notifiers.length > 3
                                        ? _c("span", [_vm._v("s")])
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  typeof notification.icon != "undefined"
                                    ? _c("img", {
                                        attrs: {
                                          src: notification.icon,
                                          alt: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(notification.message) +
                                      "\n                                        "
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          typeof notification.communityThumbnail != "undefined"
                            ? _c(
                                "div",
                                { staticClass: "c-notifications-community" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$cdn(
                                        "/img/communities/" +
                                          notification.communityId +
                                          "/" +
                                          notification.communityThumbnail
                                      ),
                                      alt: "Community Image",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(notification.communityName)
                                    ),
                                    _c("small", [
                                      _vm._v(_vm._s(notification.when)),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "c-panel__notification-btn",
                          domProps: { innerHTML: _vm._s(_vm.buttons[index]) },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleClick($event, index)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      typeof notification.article != "undefined" &&
                      notification.article !== ""
                        ? _c(
                            "div",
                            { staticClass: "c-notifications-article" },
                            [
                              _c("p", [
                                _vm._v(_vm._s(notification.article.title)),
                              ]),
                              _vm._v(" "),
                              notification.article.thumbnail
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        _vm.$root.cloudinaryUrl +
                                        "c_fill,f_auto,g_center,h_128,dpr_" +
                                        _vm.$root.$dpr +
                                        ",q_auto/v1" +
                                        notification.article.thumbnail,
                                      alt: "Notification Article",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }